import axios from "axios";
import { getApiConfig } from "../config.js";

const MASTER_ADMIN_DEEPLINKS_PATH = "/master-admin/deeplinks";

const institutionDeeplinksPath = (institutionId) =>
  `/institutions/${encodeURIComponent(institutionId)}/deeplinks`;

export const APIGetMasterAdminDeeplinks = async (setLoading, firebaseToken) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.get(
      `${apiConfig.baseURL}${MASTER_ADMIN_DEEPLINKS_PATH}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error fetching deeplinks:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APICreateDeeplink = async (
  deeplinkData,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.post(
      `${apiConfig.baseURL}${MASTER_ADMIN_DEEPLINKS_PATH}`,
      deeplinkData,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating deeplink:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIPatchDeeplink = async (
  deeplinkId,
  body,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}${MASTER_ADMIN_DEEPLINKS_PATH}/${encodeURIComponent(deeplinkId)}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating deeplink:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIDeleteDeeplink = async (
  deeplinkId,
  documentObjectId,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.delete(
      `${apiConfig.baseURL}${MASTER_ADMIN_DEEPLINKS_PATH}/${encodeURIComponent(deeplinkId)}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
        data: documentObjectId ? { _id: String(documentObjectId) } : undefined,
      }
    );
    return result;
  } catch (error) {
    console.error("Error deleting deeplink:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIGetInstitutionDeeplinks = async (
  institutionId,
  setLoading,
  firebaseToken
) => {
  if (!institutionId) return null;

  setLoading?.(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.get(
      `${apiConfig.baseURL}${institutionDeeplinksPath(institutionId)}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error fetching institution deeplinks:", error);
    return error;
  } finally {
    setLoading?.(false);
  }
};
